import {
    CONTRACTOR_ENGINEERS_REQUEST,
    CONTRACTOR_ENGINEERS_SUCCESS,
    CONTRACTOR_ENGINEERS_FAILURE,
    CONTRACTOR_ENGINEERS_SYNC_REQUEST,
    CONTRACTOR_ENGINEERS_SYNC_SUCCESS,
    CONTRACTOR_ENGINEERS_SYNC_FAILURE,
    UPDATE_CONTRACTOR_ENGINEER_REQUEST,
    UPDATE_CONTRACTOR_ENGINEER_SUCCESS,
    UPDATE_CONTRACTOR_ENGINEER_FAILURE,
    CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_REQUEST,
    CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_SUCCESS,
    CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_FAILURE,
    CONTRACTOR_ENGINEER_DOCUMENT_DELETE_REQUEST,
    CONTRACTOR_ENGINEER_DOCUMENT_DELETE_SUCCESS,
    CONTRACTOR_ENGINEER_DOCUMENT_DELETE_FAILURE,
} from '../actions';
import engineer from './contractor-engineer';

const engineerReducer = (state, action) => {
    let {data} = state;
    const {engineer: id} = action;
    const eng = data.find(b => b.id === id);
    const reduced = engineer(eng, action);
    data.splice(data.indexOf(eng), 1, reduced);
    data = [...data];

    return {...state, data};
};

export const CONTRACTOR_ENGINEERS_INITIAL_STATE = {
    isSyncing: false,
    isFetching: false,
    data: [],
    error: null,
    syncError: null,
};

const engineersReducers = {
    [CONTRACTOR_ENGINEERS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [CONTRACTOR_ENGINEERS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [CONTRACTOR_ENGINEERS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [CONTRACTOR_ENGINEERS_SYNC_REQUEST]: (state) => {
        return {...state, isSyncing: true, syncError: null};
    },
    [CONTRACTOR_ENGINEERS_SYNC_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isSyncing: false, syncError: null};
    },
    [CONTRACTOR_ENGINEERS_SYNC_FAILURE]: (state, {error}) => {
        return {...state, isSyncing: false, syncError: error};
    },
    [UPDATE_CONTRACTOR_ENGINEER_REQUEST]: engineerReducer,
    [UPDATE_CONTRACTOR_ENGINEER_SUCCESS]: engineerReducer,
    [UPDATE_CONTRACTOR_ENGINEER_FAILURE]: engineerReducer,
    [CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_REQUEST]: engineerReducer,
    [CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_SUCCESS]: engineerReducer,
    [CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_FAILURE]: engineerReducer,
    [CONTRACTOR_ENGINEER_DOCUMENT_DELETE_REQUEST]: engineerReducer,
    [CONTRACTOR_ENGINEER_DOCUMENT_DELETE_SUCCESS]: engineerReducer,
    [CONTRACTOR_ENGINEER_DOCUMENT_DELETE_FAILURE]: engineerReducer,
};

export default function engineers(state = CONTRACTOR_ENGINEERS_INITIAL_STATE, action) {
    let reducer = engineersReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-engineers.js